import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import './plugins/globalComponents'
import './plugins/globalFunctions'
import './plugins/vee-validate'
import { initFilters } from './plugins/filters'
import VuetifyConfirm from 'vuetify-confirm'

initFilters()

Vue.config.productionTip = false

Vue.use(VuetifyConfirm, {
  vuetify
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
